import { OptionsType } from "apis/types/other";

export const transformToOptions = (response: any, labelKey?: string, valueKey?: string): OptionsType[] => {
    if (response?.results) {
        return response?.results?.map((item: any) => ({
            label: item?.[labelKey || "name"],
            value: item?.[valueKey || "id"],
        }));
    }
    return [];
};